import { createApp, h } from 'vue';
import { ModalManager } from '@studyportals/modal';
import App from '@/presentation/components/App.vue';
import GlobalPlugin from '@/vue-globals';
export default class ModalHandler {

	public constructModalManager(): void {
		if (typeof window['ModalManager'] === 'undefined') {
			window['ModalManager'] = new ModalManager();
		}

		this.createPopupPlaceholder();
	}

	private createPopupPlaceholder(): void {
		const bestFitOverview = document.createElement('div');
		bestFitOverview.classList.add('BestFitOverview');
		document.body.appendChild(bestFitOverview);


		const app = createApp({
			render: () => {
				return h(App);
			},
		}); 
		app.use(GlobalPlugin);
		app.mount(bestFitOverview);
	}
}